import { AbstractControl, ValidationErrors } from '@angular/forms';

export function nameValidator(control: AbstractControl): ValidationErrors | null {
	const value = control.value?.trim();

	if (!value) return null;

	if (/\d/.test(value)) {
		return { hasNumber: true };
	}

	if (/[^a-zA-Z\s]/.test(value)) {
		return { hasSpecialChar: true };
	}

	return null;
}


export function strongPasswordValidator(control: AbstractControl): ValidationErrors | null {

	const value = control.value || '';
	const hasUpperCase = /[A-Z]/.test(value);
	const hasLowerCase = /[a-z]/.test(value);
	const hasNumber = /\d/.test(value);
	const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(value);
	const isValidLength = value.length >= 8;
	const passwordValid = hasUpperCase && hasLowerCase && hasNumber && hasSpecialChar && isValidLength;

	return passwordValid ? null : { weakPassword: true };
}